import Marquee from "react-fast-marquee";
import { Crosshair } from "@phosphor-icons/react";

const ITEMS = ["GunBroker", "eBay", "TacSwap", "Infinite Armory", "Facebook"];

export const MarqueeStrip = () => (
  <div data-testid="marketplace-marquee" className="border-y border-white/10 py-8 overflow-hidden bg-[#050505]">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((name, i) => (
        <span key={name} className="flex items-center">
          <span
            className={`font-display uppercase text-5xl md:text-7xl px-8 ${
              i % 3 === 0 ? "text-outline" : i % 3 === 1 ? "text-white" : "text-outline-purple"
            }`}
          >
            {name}
          </span>
          <Crosshair size={28} weight="duotone" className={`${i % 2 === 0 ? "text-primary" : "text-violet-400"} mx-2`} />
        </span>
      ))}
    </Marquee>
  </div>
);
